import { useGlobalStore } from "@/mono/store/global";
import { useEffect, useRef, useCallback } from "react";
import { debounce } from "../common";

// TODO: Callback should just be first parameter, rest should be config
const useResize = (
  callback,
  { debounce: debounceDuration = null, immediate = false } = {},
  deps = []
) => {
  const windowSize = useGlobalStore((s) => s.windowSize);
  const hasResized = useRef(false);

  const debouncedCallback = useRef(
    debounceDuration !== null ? debounce(callback, debounceDuration) : callback
  ).current;

  useEffect(() => {
    if (immediate) {
      callback(windowSize);
    }
  }, []);

  useEffect(() => {
    if (!hasResized.current) {
      hasResized.current = true;
      return;
    }

    if (typeof callback === "function") {
      debouncedCallback(windowSize);
    }
  }, [windowSize, ...deps]);
};

export default useResize;
